import React from 'react';
import { type Tag } from '../../hooks/useTags';
import { TagTypeahead } from '../TagTypeahead';

interface Props {
  projectId: string;
  title: string;
  tags: Tag[];
  onChange: (tags: Tag[]) => void;
}

export function TagBooleanItem({ projectId, title, tags, onChange }: Props) {
  return (
    <div className="well well-small" style={{ backgroundColor: '#fff' }}>
      <span className="label label-default">{title}</span>
      <br />
      <br />
      <TagTypeahead projectId={projectId} selected={tags} onChange={onChange} />
    </div>
  );
}
